import React, { useEffect, useState } from 'react'
import { store } from '../../../../redux/store';
import { Table, ConfigProvider, Col, Divider, Drawer, Row } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './index.css'
import moment from 'moment';
//引入axios 进行服务器接口请求
import axios from "axios";
export default function BasketHistory() {
  const [dataSource, setDataSource] = useState([]);

  let navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const customerId = searchParams.get('customerId');//订单主id
  const activeKey = searchParams.get('activeKey');//1 销售 2购买
  useEffect(() => {
    queryBasketHistoryList();
  }, []); // 空数组确保只在挂载时设置观察者
  //返回上一层
  function backBasketList() {
    navigate("/main/basket")
  }
  const token = store.getState().uData.token;
  function queryBasketHistoryList() {
    //请求后台接口
    // / 设置全局的Authorization头
    axios.defaults.headers.common['token'] = token;
    const objData = {
      "customerId": customerId,
      "activeKey": activeKey
    }
    axios.post('/api/basket/basketHistoryList',
      JSON.stringify(objData),
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    ).then(
      response => {
        if (response.data.code === "200") {
          setDataSource(response.data.data);
        } else {
          setDataSource({});
        }
      },
      error => {
        navigate("/error");
      }
    )
  }

  const columns = [
    {
      title: '客户名称',
      dataIndex: 'customerName',
      key: 'customerName',
      align: 'center',
      width: 150,
    },
    {
      title: '容器名称',
      dataIndex: 'packName',
      key: 'packName',
      width: 150,
      align: 'center',
    },
    {
      title: '押入数量',
      dataIndex: 'pushInNum',
      key: 'pushInNum',
      width: 150,
      align: 'center',
    },
    {
      title: '押出数量',
      dataIndex: 'pushOutNum',
      key: 'pushOutNum',
      width: 150,
      align: 'center',
    },
    {
      title: '操作时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 150,
      align: 'center',
      sorter: (a, b) => moment(a.createTime).diff(moment(b.createTime)),
      defaultSortOrder: 'ascend',
      render: (val) => moment(val).format('YYYY-MM-DD HH:mm:ss')
    },
    {
      title: '操作员',
      dataIndex: 'createUser',
      key: 'createUser',
      width: 150,
      align: 'center',
    }
  ];
  return (
    <React.Fragment>
      <div className='back_basket_list'>
        <div className='back_title' onClick={() => backBasketList()}>&lt;返回上一层</div>
        <div className="item-location">
          当前所在位置 : 筐子操作历史信息页
        </div>
      </div>
      <div className="data-div">
        <ConfigProvider locale={zhCN}>
          <Table
            columns={columns}
            rowKey="id"
            dataSource={dataSource}
            bordered
            pagination={{ position: ['bottomCenter'], hideOnSinglePage: 'true' }}
            scroll={{ x: 1500 }}
            sticky={{ offsetHeader: 0 }}
          />
        </ConfigProvider>
      </div>
    </React.Fragment>

  )
}
